var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.loading)?_c('v-app',{attrs:{"id":"inspire"}},[_c('v-container',[_c('loading')],1)],1):_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }